// extracted by mini-css-extract-plugin
export default {"center":"styles_center__tNSQT","text":"styles_text__dGsDC"};